import { render, staticRenderFns } from "./ConfirmRevisit.vue?vue&type=template&id=b55c79f4&scoped=true"
import script from "./ConfirmRevisit.vue?vue&type=script&lang=js"
export * from "./ConfirmRevisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c79f4",
  null
  
)

export default component.exports